import VerticalTabsComponent from "./vertical-tabs-component";
import VerticalTabsConfig from "./vertical-tabs-config";
import VerticalTabsAdvancedConfig from "./vertical-tabs-advanced-config";

export default {
  VerticalTabsComponent,
  VerticalTabsConfig,
  VerticalTabsAdvancedConfig
};
